import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, switchMap, take } from 'rxjs';
import { PlatformAPIClientAuthorizationService } from '@services/platform-api-client-authorization.service';

@Component({
  selector: 'app-authorization-callback',
  template: `<p>Signing in...</p>`,
})
export class AuthorizationCallbackComponent implements OnInit {
  private authService = inject(PlatformAPIClientAuthorizationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        take(1),
        switchMap((params) => {
          const code = params['code'];
          if (code?.length) {
            return this.authService.exchangeCodeForToken(code);
          }
          console.debug('Authorization callback: no code param, redirecting to home');
          this.router.navigate(['/']);
          return EMPTY;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((response) => {
        if (response.success && response.data) {
          this.authService.setPKCEToken(response.data);
          this.router.navigate(['/video']);
        } else {
          console.error('PKCE token exchange failed, redirecting to home');
          this.authService.clearSession();
          this.router.navigate(['/']);
        }
      });
  }
}
